import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "ttag";

import { errorToast, useToastStore } from "@/shared/ui";
import {
  markMedicationAsReceived,
  medicationRequestQueriesStore,
} from "../api";

export const useMarkMedicationAsReceived = () => {
  const pushToast = useToastStore((state) => state.pushToast);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markMedicationAsReceived,
    onSuccess: () => {
      void pushToast({
        type: "success",
        title: t`Success`,
        message: t`Great! Your medication was marked as received.`,
      });

      void queryClient.invalidateQueries({
        queryKey: medicationRequestQueriesStore.medicationRequest.list.queryKey,
      });
    },
    onError: errorToast,
  });
};
